import { css } from '@emotion/react';

export const typeSelectCss = css`
	width: 5.5rem;
`;

export const reasonSelectCss = css`
	width: 100%;
`;
